const initMenu = () => {
    const toggler= document.querySelector('.navbar-toggler');
    const navbar = document.querySelector('.navbar');
    if(toggler){
        toggler.addEventListener('click', function() {
            navbar.classList.toggle('mobil-menu-opened');
        });
    }
    const dropdownMenu = document.querySelectorAll('.dropdown');
    dropdownMenu.forEach(dropdown => {
        dropdown.addEventListener('show.bs.dropdown', event => {
            dropdown.classList.add('ks-menu-item-open');
        });
        dropdown.addEventListener('hide.bs.dropdown', event => {
            dropdown.classList.remove('ks-menu-item-open');
        });
    });

};
export default initMenu;
